import React from "react";
import { GridColumn } from "emotion-flex-grid";
import HeadTitle from "components/HeadTitle";
import { Container, Row, Content } from "styles/General.styled";
import SearchContainer from "components/SearchPage";

const Search = () => {
  return (
    <>
      <HeadTitle title={"Foody | Search"} />
      <Container>
        <Row>
          <Content>
            <GridColumn pt={["", "l1"]} pb={["xl2", "xxl"]}>
              <SearchContainer />
            </GridColumn>
          </Content>
        </Row>
      </Container>
    </>
  );
};

export default Search;
